import type { ReactNode } from 'react';
import { GleamSpark } from '@/components/ui/GleamSpark';

type EyebrowProps = {
  children: ReactNode;
  className?: string;
  /** Renders a small gold `GleamSpark` before the label. Reserved for
   * primary eyebrows (the Home hero, each page's `PageHeader`) — secondary,
   * in-page eyebrows stay plain so the gleam reads as a rare accent. */
  spark?: boolean;
};

/** Small uppercase letter-spaced label, matching the mockup's `.eyebrow`. */
export const Eyebrow = ({ children, className, spark }: EyebrowProps) => (
  <span
    className={`text-primary-deep inline-flex items-center gap-[9px] text-[11.5px] font-semibold tracking-[.22em] uppercase ${className ?? ''}`}
  >
    {spark ? <GleamSpark className="h-3 w-3 shrink-0" /> : null}
    {children}
  </span>
);
